export class WidgetDataRequestFailure extends Error {
  constructor(msg: string, method = 'unknown method') {
    super(`Widget data request failed [${method}]: ${msg}`);

    Object.setPrototypeOf(this, WidgetDataRequestFailure.prototype);
  }
}
